(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jbd-commission-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jbd-card-carousel')) {
  customElements.define('jbd-card-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.jbd-card-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.jbd-card-carousel__slide'));
      if (!this.track || this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.dots = Array.from(this.querySelectorAll('[data-slide]'));
      this.arrows = Array.from(this.querySelectorAll('[data-direction]'));
      this.querySelectorAll('[hidden]').forEach(control => { control.hidden = false; });
      this.arrows.forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.direction)), options));
      this.dots.forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.slide)), options));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('focusin', event => {
        const slide = event.target.closest('.jbd-card-carousel__slide');
        if (slide) this.go(this.slides.indexOf(slide));
      }, options);
      this.track.addEventListener('pointerdown', event => { this.startX = event.clientX; this.dragged = false; }, options);
      this.track.addEventListener('pointerup', event => { this.dragged = Math.abs(event.clientX - this.startX) > 10; }, options);
      this.track.addEventListener('click', event => {
        if (this.dragged) { event.preventDefault(); event.stopPropagation(); this.dragged = false; }
      }, { ...options, capture: true });
      this.observer = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
        this.update();
      });
      this.observer.observe(this.track);
      this.update();
    }
    go(index) {
      const next = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1))));
      this.dots.forEach((dot, index) => {
        if (index === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.arrows.forEach(button => { button.disabled = Number(button.dataset.direction) < 0 ? this.index === 0 : this.index === this.slides.length - 1; });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
